import ApiManager from '../../utils/ApiManager'
import _ from 'lodash'
import Constants from '@/utils/Constants'
import DownloadService from '@/utils/download'
import downloadUtil from '@/utils/downloadUtil'
import analyzeResultService from './service/analyzeresult'
import analyzeResultUtils from './utils/analyzeresult'
import ChartUtil from '@/utils/ChartUtil'
import moment from 'moment/moment'
import Vue from 'vue'

const state = {
  initLoaded: false,
  isListLoading: false,
  message: {
    content: '',
    type: ''
  },
  maxTableItems: 10000,
  labelOverMaxItems: '',
  headers: [
  ],
  vtColumns: [],
  items: [],
  vtOptions: {
    filterByColumn: true,
    resizableColumns: false,
    pagination: {
      dropdown: false,
      chunk: 100,
      edge: true,
      align: 'center',
      nav: 'scroll'
    },
    texts: {
      count: '{from} - {to} / {count} 件|{count} 件|1 件',
      filterPlaceholder: '',
      noResults: '対象のデータはありません',
      filterBy: 'Filter',
      defaultOption: 'Select'
    },
    perPageValues: [],
    perPage: 100,
    headings: {},
    cellClasses: {},
    listColumns: {},
    filterable: []
  },
  historyData: {
    analyze_target_code: '',
    tabs: []
  },
  detail_info: [
    {
      year_month: '201711',
      purchase_year_month: '201611'
    },
    {
      year_month: '201811',
      purchase_year_month: '201810'
    }
  ],
  ages: null
}

const actions = {
  resetData ({ state, commit }) {
    commit('setResetData')
  },
  async getHistoryData ({ state, commit }, id) {
    commit('setListLoading', true)
    const response = await ApiManager.request('History').historyDetail(id)
    if (response.data.code !== 200000) {
      commit('processError', response.data.data.message)
    } else {
      commit('setHistoryData', response.data.data)
    }
    commit('setListLoading', false)
  },
  async initData ({ state, commit }, id) {
    commit('setInitLoaded', false)
    commit('setListLoading', true)
    commit('setResetData')

    const response = await ApiManager.request('History').historyDetail(id)
    if (response.data.code !== 200000) {
      commit('processError', response.data.data.message)
      commit('setListLoading', false)
    } else {
      const data = response.data.data
      Vue.localStorage.set('aggregate_fixed_columns', JSON.stringify(data.aggregate_fixed_columns))
      commit('setInitData', data)
      commit('setListLoading', false)

      await this.dispatch('analyzeresult/getResultData', {
        targetCode: data.analyze_target_code,
        historyId: data.id,
        type: state.historyData.tabs && state.historyData.tabs.length > 0 ? state.historyData.tabs[0].key : null,
        pageNo: 1,
        pageSize: state.maxTableItems + 1
      })
      commit('setListLoading', true)
      if (state.historyData.tabs && state.historyData.tabs.length > 0) {
        if (data.analyze_target_code !== 'IF00010') { // IF00010の「集計結果」タブチャートなし
          await this.dispatch('chartdata/getChartData', {
            targetCode: data.analyze_target_code,
            historyId: data.id,
            type: state.historyData.tabs[0].key,
            conditions: data.conditions,
            yAxis: data.analyze_target_code === 'IF00010' ? 'base_purchase_qty' : 'purchase_qty_composition_rate_card',
            ages: state.ages
          })
        }
      } else {
        if (data.analyze_target_code === 'IF00006' ||
          data.analyze_target_code === 'IF00007' ||
          data.analyze_target_code === 'IF00011' ||
          data.analyze_target_code === 'IF00025') {
          await this.dispatch('chartdata/getChartData', {
            targetCode: data.analyze_target_code,
            historyId: data.id,
            conditions: data.conditions
          })
        }
      }
    }
    commit('setListLoading', false)
    commit('setInitLoaded', true)
  },
  async exportReport ({ state, commit }, { param, chartObject }) {
    commit('setListLoading', true)
    param.id = state.historyData.id
    if (chartObject) {
      let imageData = ChartUtil.getChartImage(chartObject)
      param.image_data = imageData
    }
    await analyzeResultService.downloadReport(param).then((response) => {
      if (param.mail_need === '1') {
        commit('processSuccess', 'メール送信しました。')
      } else {
        response.export_type = param.export_type
        commit('setExportReport', response)
      }
    }).catch(() => {
      commit('processError', 'ファイルダウンロードに失敗しました。分析条件の絞り込みにご協力ください。')
    })
    commit('setListLoading', false)
  },
  async exportItems ({ state, commit }, param) {
    commit('setListLoading', true)
    param.id = state.historyData.id
    const response = await analyzeResultService.downloadItems(param)
    response.export_type = param.export_type
    response.code_pattern = param.code_pattern
    commit('setExportItems', response)
    commit('setListLoading', false)
  },
  async lockMemberGroup ({ state, commit }, memberGroup) {
    commit('setListLoading', true)
    let param = {}
    let memberCondition = _.cloneDeep(state.historyData.conditions)
    if (analyzeResultUtils.analyze_without_product(memberCondition.type)) {
      memberCondition.product.item_base.analyze.is_all = 1
    }
    memberCondition.type = 'IF00000'
    memberCondition.member_group_name = memberGroup.name
    memberCondition.member_group_tag = memberGroup.tagName
    memberCondition.publish_setting = memberGroup.publishSetting
    param.analyze = memberCondition
    const response = await ApiManager.request('Analyze').analyzeStart(param)
    console.log(response)
    if (response.data.code !== 200000) {
      commit('processError', response.data.data.message)
    }
    commit('setListLoading', false)
  },
  async getResultData ({ state, commit }, { targetCode, historyId, type, pageNo, pageSize, sortField, sortType }) {
    if (state.isListLoading) {
      return
    }
    commit('setListLoading', true)

    if (!pageSize) {
      pageSize = state.maxTableItems + 1
      pageNo = 1
    }
    const response = await analyzeResultService.getResultData(targetCode, historyId, type, pageNo, pageSize, sortField, sortType)

    if (response.data.code !== 200000) {
      commit('processError', response.data.data.message)
    } else {
      response.data.data.analyze_target_code = targetCode
      commit('setResultData', response.data.data)
    }
    commit('setListLoading', false)
  },
  async download ({ state, commit }, slug) {
    commit('setListLoading', true)
    const response = await DownloadService.downloadAnalyzeResult(slug)
    const name = slug.indexOf('/') > 0 ? slug.split('/')[1] : slug
    commit('setDetailFile', { data: response, name: name })
    commit('setListLoading', false)
  }
}

const mutations = {
  setInitLoaded (state, data) {
    state.initLoaded = data
  },
  setListLoading (state, data) {
    // Listローディング状態
    state.isListLoading = data
    if (data) {
      this.dispatch('loading/loadingPagePlus')
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  },
  setHistoryData (state, data) {
    state.historyData = data
  },
  setInitData (state, data) {
    state.historyData = data
    let tabs = analyzeResultUtils.getTabData(data.analyze_target_code)
    state.historyData.tabs = tabs
  },
  setExportReport (state, data) {
    let fileName = state.historyData.analyze_target_name
    if (state.historyData.analyze_target_code === 'IF00007' && state.historyData.condition_jp && typeof state.historyData.condition_jp.type_mode !== 'undefined') {
      switch (state.historyData.condition_jp.type_mode) {
        case 0:
          fileName = '併買分析（期間併買）'
          break
        case 1:
          fileName = '併買分析（直前）'
          break
        case 2:
          fileName = '併買分析（直後）'
          break
      }
    }

    if (data.export_type === 1) {
      downloadUtil(data, fileName, 'csv')
    } else {
      downloadUtil(data, fileName, 'xlsx')
    }
  },
  setExportItems (state, data) {
    let codePattern = ''
    if (data.code_pattern === 2) {
      codePattern = '_jan'
    }
    if (data.export_type === 1) {
      downloadUtil(data, 'itembase_' + moment().format('YYYYMMDDHHmmss') + codePattern + '.csv')
    } else {
      downloadUtil(data, 'itemtarget_' + moment().format('YYYYMMDDHHmmss') + codePattern + '.csv')
    }
  },
  setResultData (state, data) {
    state.headers = []
    state.vtColumns = []
    state.vtOptions.headings = {}
    state.vtOptions.cellClasses = {}
    state.vtOptions.filterable = []

    if (data.detail_info.data.length >= state.maxTableItems) {
      state.labelOverMaxItems = '分析結果が多いため ' + state.maxTableItems + '件を読み込んでいます'
    } else {
      state.labelOverMaxItems = ''
    }

    state.ages = data.ages
    state.items = data.detail_info.data
    const targetCode = data.analyze_target_code

    if (targetCode === 'IF00029') {
      if (state.labelOverMaxItems) {
        state.labelOverMaxItems += '<br/>'
      }
      state.labelOverMaxItems += '全国パネル平均より1.1倍以上：<span style="color: #ffd700">■</span> '
      state.labelOverMaxItems += '全国パネル平均より0.9倍以下：<span style="color: #87cefa">■</span>'
    } else if (targetCode === 'IF00024') {
      if (state.labelOverMaxItems) {
        state.labelOverMaxItems += '<br/>'
      }
      state.labelOverMaxItems += '1.10以上：<span style="color: #ffd700">■</span> '
      state.labelOverMaxItems += '0.90以下：<span style="color: #87cefa">■</span>'
    }

    let detailHeader = data.detail_header
    _.forEach(detailHeader, function (item) {
      let header = {}
      let addClass = {}
      let addFilter = {}
      let name

      name = item.name
      header.value = name
      header.result_type = item.type

      state.headers.push(header)
      state.vtColumns.push(name)
      state.vtOptions.headings[name] = item.name_jp

      if (item.type === 'int') {
        state.vtOptions.cellClasses[name] = []
        addClass = {
          class: 'td-int',
          condition: () => true
        }
        state.vtOptions.cellClasses[name].push(addClass)
      } else if (item.type === 'float') {
        state.vtOptions.cellClasses[name] = []
        addClass = {
          class: 'td-int',
          condition: () => true
        }
        state.vtOptions.cellClasses[name].push(addClass)
      } else if (item.type === 'percent') {
        state.vtOptions.cellClasses[name] = []
        addClass = {
          class: 'td-per',
          condition: () => true
        }
        state.vtOptions.cellClasses[name].push(addClass)
      } else {
        state.vtOptions.filterable.push(name)
      }

      if (name in Constants.ResultTableFilterSelect) {
        //  データから key:name の配列を抜き出す
        let filtered = state.items.map(x => x[name])
        //  ユニーク化
        filtered = [...new Set(filtered)]
        let filtered2 = filtered.filter(n => n !== '')

        //  selectのリスト化
        addFilter = filtered2.reduce((acc, item) => {
          let obj = {
            id: item,
            text: item
          }
          acc.push(obj)
          return acc
        }, [])
        state.vtOptions.listColumns[name] = addFilter
      }
    })

    if (targetCode === 'IF00029') {
      if (!state.vtOptions.cellClasses['base_trial_rate']) {
        state.vtOptions.cellClasses['base_trial_rate'] = []
      }
      state.vtOptions.cellClasses['base_trial_rate'] = state.vtOptions.cellClasses['base_trial_rate'].concat(
        analyzeResultUtils.getCellClasses(targetCode, 'base_trial_rate', 'panel_trial_rate'))

      if (!state.vtOptions.cellClasses['base_repeat_rate']) {
        state.vtOptions.cellClasses['base_repeat_rate'] = []
      }
      state.vtOptions.cellClasses['base_repeat_rate'] = state.vtOptions.cellClasses['base_repeat_rate'].concat(
        analyzeResultUtils.getCellClasses(targetCode, 'base_repeat_rate', 'panel_repeat_rate'))
    } else if (targetCode === 'IF00024') {
      _.forEach(_.filter(detailHeader, item => {
        return _.startsWith(item.name, 'index_')
      }), item => {
        if (!state.vtOptions.cellClasses[item.name]) {
          state.vtOptions.cellClasses[item.name] = []
        }
        state.vtOptions.cellClasses[item.name] = state.vtOptions.cellClasses[item.name].concat(
          analyzeResultUtils.getCellClasses(targetCode, item.name, null, item.type))
      })
    }

    // console.log(state.vtOptions)
    // console.log(state.headers)
    // console.log(state.vtColumns)
    // console.log(state.items)

    this.dispatch('loading/loadingPageMinus')
  },
  processError (state, data) {
    state.message = { type: 'error', content: data }
  },
  processSuccess (state, data) {
    state.message = { type: 'success', content: data }
  },
  setResetData (state) {
    state.message = { type: '', content: '' }
    state.historyData.tabs = []
    state.historyData.analyze_target_code = ''
    state.headers = []
    state.vtColumns = []
    state.items = []
    state.vtOptions.headings = {}
    state.vtOptions.cellClasses = {}
    state.vtOptions.listColumns = {}
    state.vtOptions.filterable = []
  },
  setDetailFile (state, data) {
    downloadUtil(data.data, data.name)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
